import { InfluencerProfileOverview, InfluencerProfileOverviewProps } from '../shared';

type InfluencerFacebookProfileOverviewProps = InfluencerProfileOverviewProps;

export const InfluencerFacebookProfileOverview = (props: InfluencerFacebookProfileOverviewProps) => (
  <InfluencerProfileOverview {...props} />
);
